import { baseService } from './base';

class S3Service {
  async auth(filename) {
    const response = await baseService.post("/api/user-content/auth", { filename });
    return response.data;
  }

  async upload(presignedUrl, authData) {
    const { file, acl } = authData;

    const contentType = authData['Content-Type'] || authData.contentType;
    const metaFilename = authData['x-amz-meta-filename'] || authData.filename;

    const headers = {
      'Content-Type': contentType,
      'x-amz-acl': acl,
      'x-amz-meta-filename': metaFilename,
    };

    try {
      const response = await baseService.put(
        presignedUrl,
        file,
        null,
        headers,
        true
      );
      return response;
    } catch (error) {
      console.error('S3 upload failed:', error.message);
      throw error;
    }
  }
}

const s3Service = new S3Service();

export { s3Service };